import { Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../../../shared";
import { AcademyService } from "../../Report/report-services/academy.service";
import { GradeLevelService } from "../../Report/report-services/grade-level.service";
import { GroupService } from "../../Report/report-services/group.service";
import { HomeroomService } from "../../Report/report-services/homeroom.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GMap } from "../bus-tracker-main-map/shared/gmap";
import { DataService_BusTrackerScanHistory } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-bus-tracker-scan-history",
	templateUrl: "./bus-tracker-scan-history.component.html",
	styleUrls: ["./bus-tracker-scan-history.component.css"],
})
export class BusTrackerScanHistoryComponent implements OnInit {
	constructor(
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private userService: UserService,
		private ScanService: DataService_BusTrackerScanHistory,
		private selectService: SchoolselectorService // private dialogService: DialogService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPreferences();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	MapExpand: any = false;
	ShowMap: any = false;
	MapPrefs: any;
	options: any;
	overlays: any = [];
	PrefLoading: any = true;

	@ViewChild(GMap)
	mapRef: GMap;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	School: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	GradeLevelLoading: any = false;
	GradeLevel: any;
	lstGradeLevel: any = [];

	AcademyLoading: any = false;
	Academy: any;
	lstAcademy: any = [];

	HomeroomLoading: any = false;
	Homeroom: any;
	lstHomeroom: any = [];

	GroupLoading: any = false;
	Group: any;
	lstGroup: any = [];

	InitStylesAndListeners: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedBusStudentRideTxn: any;
	lstBusStudentRideTxn: any = [];

	//Filter lists
	lstBusRouteTypeDesc: any = [];
	lstEntryTypeDesc: any = [];
	lstScanTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "StudentName", header: "Student" },
		{ field: "SchoolFullName", header: "School" },
		{ field: "BusNbr", header: "Bus" },
		{ field: "DriverName", header: "Driver" },
		{ field: "BusRouteDesc", header: "Route" },
		{ field: "BusRouteTypeDesc", header: "Route Type" },
		{ field: "EntryTypeDesc", header: "Entry Type" },
		{ field: "c_dateDesc", header: "Date/Time" },
		{ field: "Lat", header: "Lat" },
		{ field: "Long", header: "Long" },
		{
			field: "HorizontalAccuracy",
			header: "Accuracy (ft, lower is better)",
		},
		{ field: "ScanTypeDesc", header: "Scan Type" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPreferences() {
		this.PrefLoading = true;

		var result = this.ScanService.BusMapPreferenceSelect(this.user.personID);
		result.subscribe(
			(response) => {
				this.MapPrefs = response[0];

				this.options = {
					center: {
						lat: Number(this.MapPrefs.DefaultLat),
						lng: Number(this.MapPrefs.DefaultLong),
					},
					zoom: Number(this.MapPrefs.DefaultZoom),
				};

				this.ShowMap = true;

				this.PrefLoading = false;

				// this.loadBusStudentRideTxn();
				// this.loadGradeLevel();
				// this.UpdateMapStylesAndListeners();
			},
			(error) => {
				this.PrefLoading = false;
			}
		);
	}

	loadGradeLevel() {
		this.GradeLevelLoading = true;

		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.GradeLevel = this.lstGradeLevel[0];

				this.GradeLevelLoading = false;
			},
			(error) => {}
		);
	}

	loadAcademy() {
		this.AcademyLoading = true;

		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.Academy = this.lstAcademy[0];

				this.AcademyLoading = false;
			},
			(error) => {
				this.AcademyLoading = false;
			}
		);
	}

	loadHomeroom() {
		this.HomeroomLoading = true;

		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.Homeroom = this.lstHomeroom[0];

				this.HomeroomLoading = false;
			},
			(error) => {
				this.HomeroomLoading = false;
			}
		);
	}

	loadGroup() {
		this.GroupLoading = true;

		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.Group = this.lstGroup[0];

				this.GroupLoading = false;
			},
			(error) => {
				this.GroupLoading = false;
			}
		);
	}

	loadBusStudentRideTxn() {
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}
		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			return;
		}

		this.loading = true;

		var result = this.ScanService.ScanHistorySelectList(
			fsDate,
			feDate,
			this.School.SchoolID,
			this.GradeLevel.GradeLevelID,
			this.Academy.AcademyId,
			this.Homeroom.HomeroomId,
			this.Group.GroupID,
			this.user.userID
		);
		result.subscribe(
			(response) => {
				this.lstBusStudentRideTxn = response;

				//Load Data Filter Lists
				this.lstBusRouteTypeDesc = Array.from(new Set(this.lstBusStudentRideTxn.map((item: any) => item.BusRouteTypeDesc))).sort();
				this.lstEntryTypeDesc = Array.from(new Set(this.lstBusStudentRideTxn.map((item: any) => item.EntryTypeDesc))).sort();
				this.lstScanTypeDesc = Array.from(new Set(this.lstBusStudentRideTxn.map((item: any) => item.ScanTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadBusStudentRideTxn();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onStartDateChange(val) {
		this.StartDate = val;

		// this.loadBusStudentRideTxn();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		// this.loadBusStudentRideTxn();
	}

	onSchoolChange(val) {
		this.School = val;

		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedBusStudentRideTxn = val.data;

		this.ZoomInOnPoint();
	}
	onRowUnselect(val) {
		this.SelectedBusStudentRideTxn = null;

		this.mapRef.map.data.forEach((element) => {
			this.mapRef.map.data.remove(element);
		});
	}
	onRowDblClick(BusStudentRideTxn) {
		this.SelectedBusStudentRideTxn = BusStudentRideTxn;

		this.ZoomInOnPoint();
		if (this.MapExpand == false) {
			this.MapExpand = true;
			this.UpdateMapStylesAndListeners();
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return (
			this.loading == true ||
			this.PrefLoading == true ||
			this.GradeLevelLoading == true ||
			this.AcademyLoading == true ||
			this.HomeroomLoading == true ||
			this.GroupLoading == true
		);
	}

	ZoomInOnPoint() {
		//
		// Remove previous marker if any
		//
		this.mapRef.map.data.forEach((element) => {
			this.mapRef.map.data.remove(element);
		});

		var NextLabel: any = this.SelectedBusStudentRideTxn.StudentName;

		var NextLat: number = Number(this.SelectedBusStudentRideTxn.Lat);
		var NextLong: number = Number(this.SelectedBusStudentRideTxn.Long);

		let StudentLocation: google.maps.LatLng = new google.maps.LatLng(NextLat, NextLong);
		let StudentPoint: google.maps.Data.Point = new google.maps.Data.Point(StudentLocation);
		let StudentFeatureOptions: google.maps.Data.FeatureOptions = {
			geometry: StudentPoint,
			properties: {
				Type: "Student",
				StudentLabel: NextLabel,
				StudentName: this.SelectedBusStudentRideTxn.StudentName,
				EntryTypeID: this.SelectedBusStudentRideTxn.EntryTypeID,
			},
		};

		let StudentFeature: google.maps.Data.Feature = new google.maps.Data.Feature(StudentFeatureOptions);
		this.mapRef.map.data.add(StudentFeature);

		this.mapRef.map.setCenter({ lat: NextLat, lng: NextLong });
		this.mapRef.map.setZoom(19);
	}

	UpdateMapStylesAndListeners() {
		//
		// Only Run 1 time
		//
		if (this.InitStylesAndListeners == true) {
			return;
		}

		this.InitStylesAndListeners = true;

		/////////////////////////////////////////////////////
		// Styling
		/////////////////////////////////////////////////////

		this.mapRef.map.data.setStyle(function (feature) {
			var Type = feature.getProperty("Type");

			var ParentPath: any = "assets/images/BusTrackerMap/BusIconsV4/";

			var iconPath: any = "/assets/images/BusTrackerMap/student_icon.png";
			let nextLabel: google.maps.MarkerLabel = null;

			var NextText: any = feature.getProperty("StudentLabel");
			var NextColor: any = "Blue";
			// var NextColor: any = feature.getProperty("StudentTextColor");

			var EntryTypeID = feature.getProperty("EntryTypeID");

			if (EntryTypeID == 1) {
				iconPath = ParentPath + "StudentOn.png";
			} else if (EntryTypeID == 2) {
				iconPath = ParentPath + "StudentOff.png";
			}

			// if(feature.getProperty("LastTransaction") == true){
			//   NextText += "*";
			// }

			nextLabel = {
				text: NextText,
				color: NextColor,
				fontWeight: "Bold",
			};

			if (NextText != "") {
				return {
					icon: {
						url: iconPath,
						labelOrigin: {
							x: 17.5,
							y: -10,
						},
					},
					label: nextLabel,
					title: feature.getProperty("StudentName"),
				};
			} else {
				return {
					icon: {
						url: iconPath,
						labelOrigin: {
							x: 17.5,
							y: -10,
						},
					},
					title: feature.getProperty("StudentName"),
				};
			}
		});
	}

	////////////////////////////////////////////
}
